import {
    STUDENTREPORT_GET_MULTIPLE,
    STUDENTREPORT_GET_ONE,
    STUDENTREPORT_REGISTER_SUCCESS,
    STUDENTREPORT_REGISTER_FAIL,
    STUDENTREPORT_LOADING,
    STUDENTREPORT_LOADING_ERROR,
    STUDENTREPORT_ACTIVATE_FAIL,
    STUDENTREPORT_ACTIVATE_SUCCESS,
    STUDENTREPORT_UPDATE_SUCCESS,
    STUDENTREPORT_UPDATE_FAIL,
    STUDENTREPORT_DELETE_SUCCESS,
    STUDENTREPORT_DELETE_FAIL,
    STUDENTREPORT_EDIT
} from "./../types/studentreport";

let studentreportStore = JSON.parse(localStorage.getItem('studentreport'))

const initialState = {
    isLoading: false,
    studentreports: studentreportStore ? studentreportStore : [],
    studentreport:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newStudentreport = [...aluu];
    newStudentreport.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newStudentreport;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case STUDENTREPORT_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case STUDENTREPORT_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case STUDENTREPORT_GET_MULTIPLE:
            localStorage.setItem('studentreport', JSON.stringify(action.payload));
            return {
                ...state,
                studentreports : action.payload,
                studentreport : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case STUDENTREPORT_GET_ONE:
            let all = [...state.studentreports];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                studentreport : ses,
                MSG:"DONE!!!"
            };
        case STUDENTREPORT_REGISTER_SUCCESS:
            localStorage.setItem('studentreport', JSON.stringify([...state.studentreports, action.payload]));
            return {
                ...state,
                studentreports: [...state.studentreports, action.payload],
                msg:action.msg
            }; 
        case STUDENTREPORT_ACTIVATE_SUCCESS:
            let ac = changeState(state.studentreports, action.payload);
            localStorage.setItem('studentreport', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                studentreports: ac
            }
        case STUDENTREPORT_DELETE_SUCCESS:
            let rem = state.studentreports.filter(cat => cat.id != action.payload);
            localStorage.setItem('studentreport', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                studentreports: rem
            }
        case STUDENTREPORT_UPDATE_SUCCESS:
            const findInd = state.studentreports.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.studentreports];
            newState[findInd] = action.payload;
            localStorage.setItem('studentreport', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                studentreports : newState,
                studentreport:action.payload
            }; 
        case STUDENTREPORT_LOADING_ERROR:
        case STUDENTREPORT_ACTIVATE_FAIL:
        case STUDENTREPORT_REGISTER_FAIL:
        case STUDENTREPORT_DELETE_FAIL:
        case STUDENTREPORT_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func